"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vue = _interopRequireDefault(require("vue"));
var _vuePhoneNumberInput = _interopRequireDefault(require("vue-phone-number-input"));
require("vue-phone-number-input/dist/vue-phone-number-input.css");
_vue.default.component('vue-phone-number-input', _vuePhoneNumberInput.default);